var _defs, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCripto42Logo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#878787;}.cls-3{fill:#fff;}.cls-4{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1);}"), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 38,
    height: 38,
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 38 38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 38,
    height: 38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 38,
    height: 38
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u041C\u043E\u043D\u0442\u0430\u0436\u043D\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_4_\\u043A\\u043E\\u043F\\u0438\\u044F_",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 4 (\\u043A\\u043E\\u043F\\u0438\\u044F)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 42,
    height: 42
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_3",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 21,
    cy: 21,
    r: 18.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.88,7.5H13.13a2.73,2.73,0,0,0-2.63,2.77V31.82a2.65,2.65,0,0,0,2.63,2.68H28.88a2.65,2.65,0,0,0,2.62-2.68V10.27A2.73,2.73,0,0,0,28.88,7.5Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_7",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.69,9.5a.89.89,0,0,1,.81.94V31.66a.8.8,0,0,1-.81.84H13.31a.8.8,0,0,1-.81-.84V10.44a.89.89,0,0,1,.81-.94H28.69m0-1H13.31a1.88,1.88,0,0,0-1.81,1.94V31.66a1.81,1.81,0,0,0,1.81,1.84H28.69a1.81,1.81,0,0,0,1.81-1.84V10.44A1.88,1.88,0,0,0,28.69,8.5Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_8",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "21 26.9 18 26.9 18 37.9 21 35.59 24 37.9 24 26.9 21 26.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.52,29.4v7.73L21,35.19l-2.52,1.94V29.4a3.45,3.45,0,0,1-1-2.07V39.08L21,36.4l3.48,2.68V27.33A3.45,3.45,0,0,1,23.52,29.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 21,
    cy: 26.97,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21,23.47A3.5,3.5,0,1,1,17.5,27a3.5,3.5,0,0,1,3.5-3.5m0-1A4.48,4.48,0,1,0,25.48,27,4.48,4.48,0,0,0,21,22.5Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_5",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.5,
    y: 11.5,
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.5,
    y: 15.5,
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.5,
    y: 19.5,
    width: 11,
    height: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCripto42Logo);
export default __webpack_public_path__ + "static/media/cripto_42_logo.11256983575cf8f868739db5dac7d445.svg";
export { ForwardRef as ReactComponent };